import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AddBlog.css";
import RichTextEditor from "./RichTextEditor"; // adjust the path if needed

const AddBlog = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        title: "",
        slug: "",
        intro: "",
        author: ""
    });

    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage({ type: "", text: "" });

        try {
            const token = localStorage.getItem("token");

            await axios.post(
                "http://localhost:8080/api/blogs",
                { ...form, content },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setMessage({ type: "success", text: "Blog created successfully!" });
            // navigate("/blogs");
        } catch (err) {
            console.error(err.response?.data || err);
            setMessage({
                type: "error",
                text: err.response?.data?.message || "Failed to create blog"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="addblog-container">
            <h1 className="addblog-title">Create New Blog</h1>

            {message.text && (
                <div className={`addblog-message ${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="addblog-form" onSubmit={handleSubmit}>
                <div className="grid">
                    <input
                        type="text"
                        name="title"
                        placeholder="Blog Title"
                        value={form.title}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="text"
                        name="slug"
                        placeholder="Slug (e.g. my-blog)"
                        value={form.slug}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="text"
                        name="author"
                        placeholder="Author (optional)"
                        value={form.author}
                        onChange={handleChange}
                    />

                    <textarea
                        name="intro"
                        placeholder="Short intro"
                        value={form.intro}
                        onChange={handleChange}
                        rows="3"
                        required
                    />
                </div>

                {/* --- Rich Text Editor --- */}
                <RichTextEditor
                    initialContent={content}
                    onChange={(html) => setContent(html)}
                />


                <div className="addblog-submit-container">
                    <button type="submit" disabled={loading}>
                        {loading ? "Saving..." : "✅ Create Blog"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddBlog;
